import { GET_POPULAR } from '../music/actions';
import {
  DELETE_USER,
  GET_ACTIVITIES,
  GET_ARTISTS,
  GET_FOLLOWERS,
  GET_PUBLISHED_ALBUMS,
  GET_PUBLISHED_SINGLES,
  GET_PROFILE,
  GET_POPULAR_SONGS,
  GET_MY_PLAYLISTS,
  GET_PUBLIC_PLAYLISTS,
  GET_USERS,
  POST_AVATAR,
  POST_PLAYLISTS,
  PUT_FOLLOW,
  PUT_UNFOLLOW,
  SET_USER_FIELD,
} from './actions';

const initialState = {
  /**
   * All users in the platform for the admin to see
   */
  all: {
    total: 0,
    list: [],
  },
  /**
   * Artists in the platform
   */
  artists: {
    total: 0,

    countries: [],

    genres: [],

    /**
     * The filtered list of artists
     */
    list: [],
  },

  /**
   * Popular artists
   */
  popular: [],

  /**
   * The authenticated user's data
   */
  current: {
    /**
     * Private and public playlists for the authenticated user
     */
    playlists: []
  },

  /**
   * The user to show in profile page
   */
  profile: {
    /**
     * Is the current user following this loaded user?
     */
    following: false,

    /**
     * User basic profile
     */
    basic: {
      gender: 'Male',
    },

    /**
     * Activities for the current profile
     */
    activities: {
      total: 0,
      list: [],
    },

    /**
     * Published albums by this user
     */
    albums: [],

    /**
     * Published singles by this user
     */
    singles: [],

    /**
     * Most popular songs by this user
     */
    popular: [],

    /**
     * Public playlists by the given user
     */
    playlists: [],

    /**
     * Followers
     */
    followers: {
      total: 0,
      list: [],
    },
  },
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case DELETE_USER.SUCCESS:
      return {
        ...state,
        all: {
          ...state.all,
          list: state.all.list.filter((user) => user.id !== action.data.user.id),
        },
      };
    case GET_ARTISTS.SUCCESS:
      return {
        ...state,
        artists: {
          ...state.artists,
          total: action.payload.meta.total,
          list: action.payload.users,
        },
      };
    case GET_POPULAR.SUCCESS:
      return {
        ...state,
        popular: action.payload.artists,
      };
    case GET_PROFILE.SUCCESS:
      return {
        ...state,
        profile: {
          ...state.profile,
          basic: action.payload.user,
        },
      };
    case GET_FOLLOWERS.SUCCESS:
      return {
        ...state,
        profile: {
          ...state.profile,
          following: action.payload.meta.following,
          followers: {
            total: action.payload.meta.total,
            list: action.payload.followers,
          },
        },
      };
    case GET_ACTIVITIES.SUCCESS:
      return {
        ...state,
        profile: {
          ...state.profile,
          activities: {
            total: action.payload.meta.total,
            list: action.payload.activities,
          },
        },
      };
    case GET_PUBLISHED_ALBUMS.SUCCESS:
      return {
        ...state,
        profile: {
          ...state.profile,
          albums: action.payload.albums,
        },
      };
    case GET_PUBLISHED_SINGLES.SUCCESS:
      return {
        ...state,
        profile: {
          ...state.profile,
          singles: action.payload.songs,
        },
      };
    case GET_POPULAR_SONGS.SUCCESS:
      return {
        ...state,
        profile: {
          ...state.profile,
          popular: action.payload.songs,
        },
      };
    case GET_PUBLIC_PLAYLISTS.SUCCESS:
      return {
        ...state,
        profile: {
          ...state.profile,
          playlists: action.payload.playlists,
        },
      };
    case GET_MY_PLAYLISTS.SUCCESS:
      return {
        ...state,
        current: {
          ...state.current,
          playlists: action.payload.playlists,
        },
      };
    case GET_USERS.SUCCESS:
      return {
        ...state,
        all: {
          total: action.payload.meta.total,
          list: action.payload.users,
        },
      };
    case POST_AVATAR.SUCCESS:
      return {
        ...state,
        profile: {
          ...state.profile,
          basic: {
            ...state.profile.basic,
            image: action.payload.user.image,
          },
        },
      };
    case POST_PLAYLISTS.SUCCESS:
      return {
        ...state,
        current: {
          ...state.current,
          playlists: [action.payload.playlist, ...state.current.playlists],
        },
        profile: {
          ...state.profile,
          playlists: [...state.profile.playlists, action.payload.playlist],
        },
      };
    case PUT_FOLLOW.SUCCESS:
      return {
        ...state,
        profile: {
          ...state.profile,
          following: true,
        }
      };
    case PUT_UNFOLLOW.SUCCESS:
      return {
        ...state,
        profile: {
          ...state.profile,
          following: false,
        }
      };
    case SET_USER_FIELD:
      return {
        ...state,
        profile: {
          ...state.profile,
          basic: {
            ...state.profile.basic,
            [action.payload.field]: action.payload.value,
          },
        },
      };
    default:
      return state;
  }
}